import { useState, useMemo } from "react"
import ErrorRelatedReportsTable from "./components/ErrorRelatedReportsTable"
import usePagination from "../../hooks/usePagination"
import ApiError from "../../components/ApiError"
import { useErrorRelatedReports } from "../../hooks/useErrorLogs"
import { generateFilter } from "../../utils"
import { useLocation, useNavigate } from "react-router-dom"
import { formatISODate, getDateRange } from "../../utils/datetime"
import { ArrowLeft } from "@phosphor-icons/react"
import LabeledValue from "../../components/LabeledValue"

const DataDisplay = ({ data }) => {
  const navigate = useNavigate()
  // Default data in case props are missing
  data = {
    errorCode: "N/A",
    errorReason: "N/A",
    occurrences: 0,
    lastOccurrence: "--:--",
    source: "UNKNOWN",
    ...data,
  }
  const goBack = () => navigate(-1)

  return (
    <div className="bg-primary/10 rounded-md p-4 mx-4 mt-4">
      <div className="flex justify-start items-center gap-3">
        <ArrowLeft
          className="mb-2.5 cursor-pointer"
          size={24}
          onClick={goBack}
        />
        <h1 className="text-primary text-xl font-medium mb-3">
          Illustration Log Detail
        </h1>
      </div>
      <div className="grid grid-cols-4 gap-4 text-sm">
        <LabeledValue label="Staus Code:" value={data?.messageType} />
        <LabeledValue label="Staus Reson:" value={data?.errorDesc} />
        <LabeledValue label="# of Occurrences:" value={data?.occurrences} />
        <LabeledValue
          label="Last Occurrence:"
          value={formatISODate(data?.lastOccurrence)}
        />
        <LabeledValue label="Source:" value={data?.source} />
      </div>
    </div>
  )
}

const ErrorRelatedReports = () => {
  const location = useLocation()
  const { source, messageType, bodyPart, viewType, region, type, date } =
    location.state

  const { limit, onPaginationChange, page, pagination } = usePagination()
  const [filters, setFilters] = useState([])

  const interval = getDateRange(date)

  const queryFilters = useMemo(
    () => ({
      source,
      messageType: messageType ?? "",
      bodyPart,
      viewType,
      region,
      type,
      ...generateFilter(filters),
      startDate: interval.start.toISO(),
      endDate: interval.end.toISO(),
    }),
    [source, messageType, bodyPart, viewType, region, type, filters, interval]
  )

  const { data, isLoading, error, isError } = useErrorRelatedReports({
    page,
    limit,
    filters: queryFilters,
  })

  const handleSetFilters = (newFilters) => {
    setFilters(newFilters)
  }

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <>
      <DataDisplay data={location.state} />
      <ErrorRelatedReportsTable
        data={isLoading ? [] : data}
        filters={filters}
        isButtonDisabled={
          (!viewType && bodyPart !== "Brain") || source === "OUTSIDE V3"
        }
        loading={isLoading}
        pageCount={isLoading ? 0 : 1}
        pagination={pagination}
        query={location.state}
        setFilters={handleSetFilters}
        onPaginationChange={onPaginationChange}
      />
    </>
  )
}

export default ErrorRelatedReports
